<template>
  <LegalPage
    title="Contact Us"
    intro="For questions or feedback about this website, use the email address below."
    :sections="sections"
    email="contact@gbmodshub.net"
    page-name="contact"
  />
</template>

<script>
import LegalPage from '@/components/LegalPage.vue';

export default {
  name: 'Contact',
  components: {
    LegalPage,
  },
  data() {
    return {
      sections: [
        {
          heading: 'Email',
          paragraphs: [
            'Contact address: contact@gbmodshub.net',
            'Include a short subject line so we can review your message more easily. We read inquiries but cannot promise a reply to every email.',
          ],
        },
        {
          heading: 'Helpful Details',
          items: [
            'The page or topic that prompted your message.',
            'Your Android version or device model if the question is about installation.',
            'A clear description without private account details.',
          ],
        },
      ],
    };
  },
};
</script>
